import type { GoalCategory } from '@fruitful/types';
import { Button as PRButton } from 'primereact/button';
import { useState } from 'react';
import { BodySmallRegular, Icon, PlusIcon, XIcon, XStack } from 'smoothie';

import { AddNewTextEditor } from '../../common/components/GridCellEditors';
import { GoalCategoryDropdown } from './GoalCategoryDropdown';

interface AddNewWorkflowGoalProps {
    onAdd: (goal: { category: GoalCategory; description: string }) => void;
}

export const AddNewWorkflowGoal = ({ onAdd }: AddNewWorkflowGoalProps) => {
    const [isAddingNew, setIsAddingNew] = useState(false);
    const [description, setDescription] = useState('');
    const [goalCategory, setGoalCategory] = useState<null | GoalCategory>(null);

    const reset = () => {
        setIsAddingNew(false);
        setDescription('');
        setGoalCategory(null);
    };

    return (
        <XStack
            alignItems="center"
            paddingHorizontal={8}
            paddingTop={4}
            gap={12}
            width="100%"
        >
            <XStack flexGrow={1} alignItems="center" gap={16}>
                <Icon size={16} icon={PlusIcon} color="$gray800" />
                {isAddingNew ? (
                    <XStack alignItems="center" gap={8} width="80%">
                        <AddNewTextEditor
                            value={description}
                            onChange={setDescription}
                        />
                        <GoalCategoryDropdown
                            value={goalCategory}
                            onChange={(category) => {
                                setGoalCategory(category);
                            }}
                        />
                        <PRButton
                            label="Add"
                            size="small"
                            severity="success"
                            outlined
                            onClick={() => {
                                if (
                                    goalCategory != null &&
                                    description != null
                                ) {
                                    onAdd({
                                        category: goalCategory,
                                        description,
                                    });
                                    reset();
                                }
                            }}
                        />
                        <PRButton
                            size="small"
                            severity="secondary"
                            outlined
                            onClick={() => {
                                reset();
                            }}
                        >
                            <Icon icon={XIcon} />
                        </PRButton>
                    </XStack>
                ) : (
                    <BodySmallRegular
                        width="60%"
                        color="$gray800"
                        paddingVertical={10}
                        paddingHorizontal={8}
                        marginLeft={-8}
                        borderRadius={6}
                        borderWidth={1}
                        borderColor="transparent"
                        hoverStyle={{
                            cursor: 'text',
                            borderColor: '$gray300',
                        }}
                        onPress={() => {
                            setIsAddingNew(true);
                        }}
                    >
                        New goal
                    </BodySmallRegular>
                )}
            </XStack>
        </XStack>
    );
};
